import { render, staticRenderFns } from "./GeneralRequests.vue?vue&type=template&id=0815860f&scoped=true&"
import script from "./GeneralRequests.vue?vue&type=script&lang=js&"
export * from "./GeneralRequests.vue?vue&type=script&lang=js&"
import style0 from "./GeneralRequests.vue?vue&type=style&index=0&id=0815860f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0815860f",
  null
  
)

export default component.exports